'use strict';
var _ = require('lodash');
var $ = require('jquery');
var Backbone = require('backbone');
var PubSub = require('tscom-pubsub');
var template = require('../../templates/abcheader.ejs');

module.exports = Backbone.View.extend({
    className: 'view-abc-header',
    events: {
        'click .dropdown-container': 'toggleDropdown',
        'click a': 'trackEvents',
        'click .language-selector .dropdown a': 'handleLanguage'
    },

    /**
     * Initialize ABC Header View
     */
    initialize: function () {
        _.bindAll(this, 'render', 'handleClickOutsideDropdown', 'handleEscapeKey');

        this.listenTo(this.model, 'change:language', this.render);
    },
    /**
     * Render ABC Header View
     */
    render: function () {
        const languageCode = this.model.get('language');
        const currentLanguage = {
            en: 'English',
            es: 'Español',
            fr: 'Français'
        };

        var model = this.model.get('text').view_abc_header;
        var dropdownLinks = Object.values(model.nav.dropdown.list);
        var navLinks = Object.values(_.omit(model.nav, 'dropdown'));
        var mobileLinks = [].concat(navLinks, dropdownLinks);
        
        this.$el.html(template(_.extend({},
            this.model.get('text').view_abc_header,
            {
                navLinks,
                dropdownLinks,
                mobileLinks,
                languageCode: languageCode,
                currentLanguage: currentLanguage[ languageCode ]
            })));

        return this;
    },

    handleEscapeKey: function(evt) {
        var isEscape = false;
        if ('key' in evt) {
            isEscape = (evt.key === 'Escape' || evt.key === 'Esc');
        } else {
            isEscape = (evt.keyCode === 27);
        }

        if (isEscape) {
            this.handleDropdownChange($('.dropdown-container:visible').get(0), true);
        }
    },

    handleClickOutsideDropdown: function(evt) {
        const $target = $(evt.target);

        if ( !$target.closest('.dropdown-container:visible').length ) {
            this.handleDropdownChange($('.dropdown-container:visible').get(0), true);
        }
    },

    /**
     * [toggleDropdown description]
     * @return {[type]} [description]
     */
    toggleDropdown: function(e) {
        this.handleDropdownChange(e.currentTarget);
    },
    /**
     * [handleDropdownChange description]
     * @return {[type]} [description]
     */
    handleDropdownChange: function(domEl, forceClose = false) {
        var $dropdown = $(domEl).children('.dropdown').first();
        forceClose ? $dropdown.removeClass( 'open' ) : $dropdown.toggleClass( 'open' );

        var isDropdownOpen = $dropdown.hasClass( 'open' );
        var $dropdownToggle = $(domEl).find('[data-toggle-dropdown]');

        const mainView = document.getElementsByTagName('MAIN')[0];
        const userView = document.getElementsByClassName('view-user')[0];
        
        $(document).off('click', this.handleClickOutsideDropdown);
        $(document).off('keydown', this.handleEscapeKey);

        if (isDropdownOpen) {
            mainView.setAttribute('aria-hidden', true);
            userView.setAttribute('aria-hidden', true);

            $(document).on('click', this.handleClickOutsideDropdown);
            $(document).on('keydown', this.handleEscapeKey);
        } else {
            mainView.removeAttribute('aria-hidden');
            userView.removeAttribute('aria-hidden');
        }

        $dropdownToggle.toggleClass('open', isDropdownOpen);
        $dropdownToggle.attr('aria-expanded', isDropdownOpen);
    },
    /**
     * Track link click events
     */
    trackEvents: function(e) {
        var cta = $(e.currentTarget).text();
        PubSub.trigger('omniture:action','abcHeaderClick',cta);
    },

    handleLanguage: function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const lang = e.currentTarget.getAttribute('data-language');

        if( ['en', 'es', 'fr'].indexOf( lang ) >= 0 ) {
            var url = new URL( window.location );
            url.searchParams.delete('lang');
            window.history.pushState({}, '', url);
            
            this.model.set('language', lang);
        }
    }

});



// WEBPACK FOOTER //
// ./app/scripts/common/views/abcheader.js